import * as React from 'react';
import { Helmet } from 'react-helmet';
import Nav from './nav';

const Layout = ({ children, title }) => {
  const year = new Date().getFullYear();
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="flex flex-col h-full">
        <Nav />
        <div className="flex-grow">{children}</div>
        <footer className="mt-12 py-6 border-t text-sm text-center">
          &copy; {year} ICCR. All rights reserved.
        </footer>
      </div>
    </>
  );
};

export default Layout;
